module.exports = __webpack_public_path__ + "img/eye-closed.6d20375e.svg";